import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import WorkFlow from "./WorkFlow";
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class WorkFlows extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'workflow',
            IsV2: true,
            data: null,
            page: 1,
            per_page: 30,
            phrase: '',
            loading: true,
            configName: 'workflow_grid',
            moduleName: 'فرآیندهای کسب و کار',
            menuId: 221
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <WorkFlow Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <WorkFlow Caller={this} /> });
    }  
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        return <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                        <div className="card-inner p-0">
                            {this.getToolBar(false, {
                                add: true, print: false, pdf: false, excell: false, remove: false, config: false,
                                otherFilters: null
                            })}
                            <div className="nk-block">
                                <div className="card card-bordered card-stretch">
                                    <div className="card-inner-group">
                                        <div className="card-inner position-relative card-tools-toggle">
                                            <div className="card-title-group">
                                                <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                                    <div className="form-inline flex-nowrap gx-3">
                                                        <div className="form-wrap">
                                                            <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="نام" className="form-control" />
                                                        </div>
                                                        <div className="btn-wrap">
                                                            <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>

                                        {this.state.data.recordsCount <= 0 ?
                                            <div className="card-inner-group">
                                                <div className="example-alert">
                                                    <div className="alert alert-pro alert-warning">
                                                        <div className="alert-text">
                                                            <h6>توجه</h6>
                                                            <p>نتیجه ای یافت نشد</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="card-inner p-0">
                                                <div className="nk-tb-list nk-tb-ulist">
                                                    <div className="nk-tb-item nk-tb-head">
                                                        <div className="nk-tb-col text-center"><span className="sub-text">عنوان</span></div>
                                                        <div className="nk-tb-col text-center"><span className="sub-text">نوع</span></div>
                                                        <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                                    </div>
                                                    {this.state.data.records.map((record, index) =>
                                                        <div className="nk-tb-item">
                                                            <div className="nk-tb-col">
                                                                <span className="sub-text text-center">
                                                                    <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)}>{record.title}</a>
                                                                </span>
                                                            </div>
                                                            <div className="nk-tb-col">
                                                                <span className="sub-text text-center">{record.typeString}</span>
                                                            </div>
                                                            <div className="nk-tb-col nk-tb-col-tools">
                                                                <ul className="nk-tb-actions gx-1">
                                                                    <li>
                                                                        <div className="drodown">
                                                                            <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                            <div className="dropdown-menu dropdown-menu-end">
                                                                                <ul className="link-list-opt no-bdr">
                                                                                    <li>
                                                                                        <a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                                                                                            <em className="icon ni ni-cross-fill-c"></em> حذف
                                                                                        </a>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        }
                                        {this.createPaging()}
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}